// extracted by mini-css-extract-plugin
module.exports = {"root":"error-dialog_root__2ocB7","entering":"error-dialog_entering__I_VXw","entered":"error-dialog_entered__2qe77","exiting":"error-dialog_exiting__1xHf8"};